import { Option } from "../../../components/reusable-components/form/FormAutocomplete";
import { Menu } from "./Menu";
import { MenuType } from "./enums/MenuType";

export interface MenuEditConstructor
  extends Omit<Menu, "domain_id" | "area_id" | "area"> {
  domain_id: Option;
  area_id: Option;
}

export class MenuEdit implements Omit<Menu, "id" | "area"> {
  public readonly name: string;
  public readonly type: MenuType;
  public readonly domain_id: string;
  public readonly area_id: string;

  constructor(data: MenuEditConstructor) {
    this.name = data.name;
    this.type = data.type;
    this.domain_id = data.domain_id.value;
    this.area_id = data.area_id.value;
  }
}
